export type FetchState = {
    status: 'loading' | 'ready' | 'error';
    error?: string | null;
};

export default function StatusMessage({ state, onRetry }: { state: FetchState; onRetry?: () => void }) {
    if (state.status === 'loading') {
        return (
            <div className='status-message status-loading'>
                <div className='spinner' aria-hidden='true' />
                <span>Loading…</span>
            </div>
        );
    }

    if (state.status === 'error') {
        return (
            <div className='status-message status-error'>
                <p>
                    <strong>Something went wrong.</strong>
                    {state.error && <span> ({state.error})</span>}
                </p>
                {onRetry && (
                    <button className='retry-button' onClick={onRetry}>Retry</button>
                )}
            </div>
        );
    }

    return null;
}
